import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {resetPassword} from 'actions';
import WithNotifications from 'containers/WithNotifications';
import ResetPasswordView from './view';

class ResetPassword extends PureComponent{
    constructor(props){
        super(props);

        this.state={
            email:"",
        }

        this.onChange=this.onChange.bind(this);
        this.onResetPassword=this.onResetPassword.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.resetError && !this.props.resetError){
            this.props.addNotification('error',"There was a problem resetting your password");
        }
        if(nextProps.reset && !this.props.reset){
            this.setState({email:""});
            this.props.addNotification('success',"An email has been sent to you with instructions to reset your password");
        }
    }
    onChange(value,evt){
        this.setState({[evt.target.name]:value});
    }
    onResetPassword(){
        const {email} = this.state;
        this.props.resetPassword(email);
    }
    render(){
        return (
            <ResetPasswordView
                loading={this.props.loading}
                email={this.state.email}
                onChange={this.onChange}
                onSubmit={this.onResetPassword}/>
        )
    }
}

ResetPassword.contextTypes = {
    router:PropTypes.object
}

function mapStateToProps(state){
    return {
        loading:state.auth.resetting,
        reset:state.auth.reset,
        resetError:state.auth.reseterror
    }
}

export default WithNotifications(connect(mapStateToProps,{resetPassword})(ResetPassword));


// WEBPACK FOOTER //
// ./src/scenes/ResetPassword/index.js